// frontend/src/components/ErrorAlert.js
import React from "react";
import { Alert } from "react-bootstrap";

const ErrorAlert = ({ error }) => {
  if (!error) return null;

  return (
    <Alert variant="danger" className="mt-3">
      <strong>Erro:</strong> {error.message || "Ocorreu um erro inesperado."}
    </Alert>
  );
};

export default ErrorAlert;
